const Filters = {
    USAGE: 'usage',
    WIDTH: 'width',
    HEIGHT: 'height',
    DIAMETER: 'diameter',
    SPEED_INDEX: 'speed_index_numeric',
    LOAD_INDEX: 'load_index',
    MANUFACTURER: 'manufacturer',
    PRODUCT_TYPE: 'product_type',
    MODEL: 'profile_text',
    VEHICLE_TYPE: 'group',
    RUN_FLAT: 'rft',
    BUY_4_PAY_3: 'buy_3_for_4',
    CLEARANCE: 'clearance',
    INSTANT_CASH: 'instant_cash',
    FREE_FITTING: 'free_fitting',

    DISCOUNT_INSTANT_CASH_50: 'discount_instant_cash_50',
    DISCOUNT_INSTANT_CASH_80: 'discount_instant_cash_80',
    DISCOUNT_INSTANT_CASH_100: 'discount_instant_cash_100',
    DISCOUNT_INSTANT_CASH_120: 'discount_instant_cash_120',
    DISCOUNT_INSTANT_CASH_150: 'discount_instant_cash_150',
    DISCOUNT_INSTANT_CASH_160: 'discount_instant_cash_160',
    DISCOUNT_INSTANT_CASH_200: 'discount_instant_cash_200',
    DISCOUNT_INSTANT_CASH_250: 'discount_instant_cash_250',
    DISCOUNT_INSTANT_CASH_300: 'discount_instant_cash_300',
    DISCOUNT_5_OFF: 'discount_5_off',
    DISCOUNT_10_OFF: 'discount_10_off',
    DISCOUNT_15_OFF: 'discount_15_off',
    DISCOUNT_20_OFF: 'discount_20_off',
    DISCOUNT_25_OFF: 'discount_25_off',
    PROMO_GIFT_CARD_50: 'promo_gift_card_50',
    PROMO_GIFT_CARD_80: 'promo_gift_card_80',
    PROMO_GIFT_CARD_100: 'promo_gift_card_100',
    PROMO_GIFT_CARD_130: 'promo_gift_card_130',
    PROMO_GIFT_CARD_150: 'promo_gift_card_150',
    PROMO_GIFT_CARD_200: 'promo_gift_card_200',
    PROMO_GIFT_CARD_250: 'promo_gift_card_250',

    PRICE_MIN: 'price_min',
    PRICE_MAX: 'price_max',
    POSTCODE: 'postcode',
    REGISTRATION: 'registration',
    TECHNOLOGY: 'technology',
    SEASON: 'season',
    EV: 'ev',

    UTQG_TREADWEAR_GROUP: 'utqg_treadwear_group',
    UTQG_TRACTION: 'utqg_traction',
    UTQG_TEMPERATURE: 'utqg_temperature',

    LABEL_NOISE: 'label_noise',
    LABEL_WET_GRIP: 'label_wet_grip',
    LABEL_FUEL_EFFICIENCY: 'label_fuel_efficiency',

    CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP: 'customer_review_dry_traction_rating_avg_group',
    CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP: 'customer_review_low_noise_rating_avg_group',
    CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP: 'customer_review_ride_comfort_rating_avg_group',
    CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP: 'customer_review_steering_response_rating_avg_group',
    CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP: 'customer_review_tread_wear_rating_avg_group',
    CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP: 'customer_review_value_for_money_rating_avg_group',
    CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP: 'customer_review_wet_traction_rating_avg_group',

    QUALITY_SEGMENT_PREMIUM: 'quality_segment_premium',
    QUALITY_SEGMENT_VALUE: 'quality_segment_value',
    QUALITY_SEGMENT_BUDGET: 'quality_segment_budget',

    WHEEL_MODEL: 'model',
    WHEEL_DIAMETER: 'diameter',
    WHEEL_WIDTH: 'width',
    WHEEL_STUDS: 'studs',
    WHEEL_PCD: 'pcd',
    WHEEL_FINISH: 'finish',
    VEHICLE_MAKE: 'make',
    VEHICLE_YEAR: 'year',
    VEHICLE_SERIES_CHASSIS: 'seriesChassis',
    VEHICLE_MODEL: 'vehicle_model',
    VEHICLE_ENGINE: 'engine',
    VEHICLE_DETAILS: 'details',
    VEHICLE_DETAILS_LABEL: 'detailsLabel',
    VEHICLE_TYRES: 'tyres',
    VEHICLE_SERIES: 'series',
    VEHICLE_CHASSIS: 'chassis',
    VEHICLE_ENGINE_DETAILS: 'engineDetails',
    VEHICLE_YEAR_RANGE_FROM: 'yearRangeFrom',
    VEHICLE_YEAR_RANGE_TO: 'yearRangeTo',
    VEHICLE_COUNTRY_OF_ORIGIN: 'countryOfOrigin',
    VEHICLE_VIN: 'vin',
    VEHICLE_ID: 'vehicleId',
    VEHICLE_STATE: 'state',
    VEHICLE_NOT_PROVIDED_COMMENT: 'vehicleNotProvidedComment',
    TYRE_OPTIONS: 'tyreOptions',
};

export {Filters};